import * as actions from './profile-actions';
import * as mutations from './profile-mutations';
import { state } from './profile-state';

export const profile = {
  state,
  mutations,
  actions,
};
